// Password criteria checklist for the /account registration form.
// Same rules/behavior as checkout — see password-criteria.js.

import { injectCriteriaIcons, evaluatePasswordCriteria } from './password-criteria.js'

function init() {
  const passwordField = document.querySelector('#reg_password')
  const confirmField = document.querySelector('#reg_password_confirm')

  if (!passwordField) return

  injectCriteriaIcons()

  const evaluate = () => evaluatePasswordCriteria(passwordField, confirmField)

  passwordField.addEventListener('input', evaluate)
  if (confirmField) confirmField.addEventListener('input', evaluate)
}

document.addEventListener('DOMContentLoaded', init)
